import { render, staticRenderFns } from "./VirtualEmployeeEdit.vue?vue&type=template&id=e8b83420"
import script from "./VirtualEmployeeEdit.vue?vue&type=script&lang=js"
export * from "./VirtualEmployeeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports